export const DEFAULT_MEDIA_COLOR = "#f4f4f4";
// Concrete values (no CSS vars): chroma derives the tile border and text colour from them.
export const DEFAULT_MEDIA_COLOR_BY_THEME = {
  light: DEFAULT_MEDIA_COLOR,
  dark: "#3e4046",
} as const;
export const FILLER_COLOR = "var(--surface-muted)";
export const FAST_2_0 = "fast_2_0";

// https://gitlab.flamefy.me/flamefy/okast-timeline#what-are-the-zindex-values-for-all-the-elements
export const MAX_TIMELINE_Z_INDEX = 91;
export const SCHEDULING_TIMELINE_ITEM_Z_INDEX = 80;

export const MEDIA_LIBRARY_LIST_WIDTH = 300;

export const DROPZONE_BORDER_SIZE = 2;
export const SCHEDULE_BORDER_SIZE = 1;

export const VERTICAL_LINE_VARIANT_WIDTH = 2;

export const MIN_SIZE_SHOW_LABEL_ITEM_VERTICAL = 15;
export const MIN_SIZE_SHOW_LABEL_ITEM_HORIZONTAL = 25;

export const OBJECT_TYPES_SCHEDULE_ITEM = {
  OTT_HOSTED: "ott_hosted",
  ADS: "ads",
  FILLER: "filler",
  AD_BREAK: "ad_break",
  TIMESLOT: "timeslot",
  CLUSTER: "cluster",
} as const;

export const OBJECT_TYPES_SCHEDULE_TEMPLATE = "template" as const;
export const OBJECT_TYPES_SCHEDULE_DROPZONE = "drop_zone" as const;

export type ScheduleItemObjectTypeKeys =
  keyof typeof OBJECT_TYPES_SCHEDULE_ITEM;

export type ScheduleItemObjectType =
  (typeof OBJECT_TYPES_SCHEDULE_ITEM)[ScheduleItemObjectTypeKeys];

export const TYPES_INDEX_MEDIA = {
  HOSTED: "hosted",
  LIVE: "live",
  AD_BREAK: "ad_break",
} as const;

export type TypeIndexMediaKeys = keyof typeof TYPES_INDEX_MEDIA;

export type TypeIndexMedia = (typeof TYPES_INDEX_MEDIA)[TypeIndexMediaKeys];

export const DISTRIBUTION_FORMAT = {
  PULL_HLS: "pull_hls",
  PULL_HLS_SCTE: "pull_hls_scte",
  PUSH_HLS: "push_hls",
  PUSH_HLS_SCTE: "push_hls_scte",
  PULL_DASH: "pull_dash",
  PULL_DASH_SCTE: "pull_dash_scte",
  PUSH_DASH: "push_dash",
  PUSH_DASH_SCTE: "push_dash_scte",
  PULL_RTMP: "pull_rtmp",
  PULL_RTMP_SCTE: "pull_rtmp_scte",
  PUSH_RTMP: "push_rtmp",
  PUSH_RTMP_SCTE: "push_rtmp_scte",
  PULL_SRT: "pull_srt",
  PULL_SRT_SCTE: "pull_srt_scte",
  PUSH_SRT: "push_srt",
  PUSH_SRT_SCTE: "push_srt_scte",
  PULL_ZIXI: "pull_zixi",
  PULL_ZIXI_SCTE: "pull_zixi_scte",
  PUSH_ZIXI: "push_zixi",
  PUSH_ZIXI_SCTE: "push_zixi_scte",
} as const;

export type DistributionFormatKeys = keyof typeof DISTRIBUTION_FORMAT;

export type DistributionFormat =
  (typeof DISTRIBUTION_FORMAT)[DistributionFormatKeys];

export const MEDIA_LIBRARY_ITEM = "MediaLibraryItem";

export const AD_BREAK_TYPES = {
  ADPODS: "adpods",
  PRE_ADS_BUMPER: "pre_ads_bumper",
  POST_ADS_BUMPER: "post_ads_bumper",
} as const;

export type AdBreakTypes = (typeof AD_BREAK_TYPES)[keyof typeof AD_BREAK_TYPES];

export const OFFSET_HOURS = 12;

export const EXPORT_SCHEDULING_REPORT_FORM_ID = "exportSchedulingReportForm";
export const EXPORT_SCHEDULING_REPORT_MODAL_ID = "exportSchedulingReportModal";
